import { Box, Rating, Typography } from '@mui/material';
import { Review } from '../../interfaces/Review/Review';
import { formatLocalDate } from '../../utils/Date';
import { sharedColors } from '../../utils/Style';

type ProductReviewRowProps = {
  review: Review;
};

export const ProductReviewRow = ({ review }: ProductReviewRowProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Rating value={review.rating} readOnly size='small' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontSize: '13px', color: sharedColors.gray6 }}>
          {review.reviewerName}
        </Typography>
        <Typography sx={{ mt: 0.25 }}> • </Typography>
        <Typography sx={{ fontSize: '13px', color: sharedColors.gray6 }}>
          {formatLocalDate(review.createdAt)}
        </Typography>
      </Box>

      <Typography>{review.comment}</Typography>
    </Box>
  );
};
